<template>
  <section class="col-12 no-padding">
    <div class="col-md-12 no-padding">
      <section-header :title="$t('apps.accounting.message.journalsetdefault')"/>
      <div class="form-row">
        <div class="col-md-6">
          <div
            class="col-md-12 no-padding"
            style="height: 24px;">
            {{ $t('apps.accounting.message.journalautoopen') }}
          </div>
          <div
            class="form-group col-12 mb-0"
            style="padding: 0;">
            <div class="form-row no-padding no-margin">
              <div
                class="form-group col-6"
                style="padding: 0;">
                <div
                  class="box-input"
                  style="border-radius: 0;">
                  <vs-checkbox
                    v-model="form.journal.entry_auto_open.is_active"
                    color="#A3CA76"
                    style="float: left;position: relative;top: 1px;left: -5px;"
                  >
                    <span v-if="!form.journal.entry_auto_open.is_active">{{ $t('message.disabled') }}</span>
                    <span v-else>{{ $t('message.enabled') }}</span>
                  </vs-checkbox>
                </div>
              </div>
              <div
                class="form-group col-6"
                style="padding-left: 0;padding-right: 0;"
              >
                <div
                  class="box-input active"
                  style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding: 0;
                          display: flex;
                          align-items: center;
                        "
                >
                  <BaseDropdown
                    v-model="form.journal.entry_auto_open.repeat.type"
                    :options="autoOpenRepeatTypes"
                    class="select-inside"
                  />
                  <BaseDropdown
                    v-if="['every_month'].includes(form.journal.entry_auto_open.repeat.type)"
                    v-model="form.journal.entry_auto_open.repeat.day"
                    :options="dayOptions"
                    class="select-inside"
                  />
                  <BaseDropdown
                    v-if="['every_month', 'every_day'].includes(form.journal.entry_auto_open.repeat.type)"
                    v-model="form.journal.entry_auto_open.repeat.time"
                    :options="timeOptions"
                    class="select-inside"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6">
          <div
            class="col-md-12 no-padding"
            style="height: 24px;">
            {{ $t('apps.accounting.message.journalautoclose') }}
          </div>
          <div
            class="form-group col-12 mb-0"
            style="padding: 0;">
            <div class="form-row no-padding no-margin">
              <div
                class="form-group col"
                style="padding: 0;">
                <div
                  class="box-input"
                  style="border-radius: 0;">
                  <vs-checkbox
                    v-model="form.journal.entry_auto_close.is_active"
                    color="#A3CA76"
                    style="float: left;position: relative;top: 1px;left: -5px;"
                  >
                    <span v-if="!form.journal.entry_auto_close.is_active">{{ $t('message.disabled') }}</span>
                    <span v-else>{{ $t('message.enabled') }}</span>
                  </vs-checkbox>
                </div>
              </div>
              <div
                class="form-group col-8"
                style="padding-left: 0;padding-right: 0;"
              >
                <div
                  class="box-input active"
                  style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding: 0;
                          display: flex;
                          align-items: center;
                        "
                >
                  <BaseDropdown
                    v-model="form.journal.entry_auto_close.repeat.type"
                    :options="autoCloseRepeatTypes"
                    class="select-inside"
                  />
                  <BaseDropdown
                    v-if="['every_year'].includes(form.journal.entry_auto_close.repeat.type)"
                    v-model="form.journal.entry_auto_close.repeat.month"
                    :options="monthOptions"
                    class="select-inside"
                  />
                  <BaseDropdown
                    v-if="['every_year', 'every_month'].includes(form.journal.entry_auto_close.repeat.type)"
                    v-model="form.journal.entry_auto_close.repeat.day"
                    :options="dayOptions"
                    class="select-inside"
                  />
                  <BaseDropdown
                    v-model="form.journal.entry_auto_close.repeat.time"
                    :options="timeOptions"
                    class="select-inside"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-12">
          <div class="form-row">
            <div class="col-md-6 col-lg-3">
              <div
                class="form-group"
                style="padding: 0;"
              >
                <label>{{ $t('apps.accounting.message.journalautoopendefaultstatus') }}</label>
                <BaseDropdown
                  v-model="form.journal.entry_auto_open.default_status"
                  :options="statusOptions"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-12">
          <div class="form-row">
            <div class="col-md-6 col-lg-3">
              <div
                class="form-group"
                style="padding: 0;"
              >
                <label>{{ $t('apps.accounting.message.journalautoclosedefaultstatus') }}</label>
                <BaseDropdown
                  v-model="form.journal.entry_auto_close.default_status"
                  :options="statusOptions"
                />
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-12">
          <div class="form-row">
            <div class="col-md-6 col-lg-3">
              <div
                class="form-group"
                style="padding: 0;"
              >
                <label>{{ $t('apps.accounting.message.journalmanualdefaultstatus') }}</label>
                <BaseDropdown
                  v-model="form.journal.entry_manual.default_status"
                  :options="statusOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    defaultValues: {
      type: Object,
    },
  },

  data() {
    return {
      form: {
        journal: {
          entry_auto_open: {
            is_active: true,
            repeat: {
              type: 'every_day',
              month: 1,
              day: 1,
              time: '00:00',
            },
            default_status: 'approved',
          },
          entry_auto_close: {
            is_active: true,
            repeat: {
              type: 'every_month',
              month: 1,
              day: 1,
              time: '00:00',
            },
            default_status: 'approved',
          },
          entry_manual: {
            default_status: 'pending',
          },
        },
      },
    }
  },

  computed: {
    generateTimeArray() {
      const times = []
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 10) {
          let hour = h.toString().padStart(2, '0')
          let minute = m.toString().padStart(2, '0')
          times.push(`${hour}:${minute}`)
        }
      }
      return times
    },
    timeOptions() {
      return this.generateTimeArray.map((time) => {
        return {
          text: this.$t('apps.accounting.message.timenumber', { number: time }),
          value: time,
        }
      })
    },
    dayOptions() {
      const days = []
      for (let i = 1; i <= 31; i++) {
        days.push(i)
      }
      return days.map((day) => {
        return {
          text: this.$t('apps.accounting.message.daynumber', { number: day }),
          value: day,
        }
      })
    },
    monthOptions() {
      const months = []
      for (let i = 1; i <= 12; i++) {
        months.push(i)
      }
      return months.map((month) => {
        return {
          text: this.$t('apps.accounting.message.monthnumber', { number: month }),
          value: month,
        }
      })
    },
    autoOpenRepeatTypes() {
      return [
        {
          text: this.$t('apps.accounting.message.immediate'),
          value: 'immediate',
        },
        // {
        //   text: this.$t('apps.accounting.message.everyday'),
        //   value: 'every_day',
        // },
        // {
        //   text: this.$t('apps.accounting.message.everymonth'),
        //   value: 'every_month',
        // },
      ]
    },
    autoCloseRepeatTypes() {
      return [
        {
          text: this.$t('apps.accounting.message.everyday'),
          value: 'every_day',
        },
        {
          text: this.$t('apps.accounting.message.everymonth'),
          value: 'every_month',
        },
        {
          text: this.$t('apps.accounting.message.everyyear'),
          value: 'every_year',
        },
      ]
    },
    statusOptions() {
      return [
        {
          text: this.$t('status.jv.pending'),
          value: 'pending',
        },
        {
          text: this.$t('status.jv.approve'),
          value: 'approved',
        },
      ]
    },
  },

  watch: {
    form: {
      handler: function () {
        this.$emit('onChange', this.form.journal)
      },
      deep: true,
    },
  },

  created() {
    if (this.defaultValues) {
      this.form.journal = cloneDeep(this.defaultValues)
    }

    this.$emit('onChange', this.form.journal)
  },
}
</script>

<style scoped>
.box-input {
  position: relative;
  padding-left: 7px;
  height: 35px;
  background: #fff;
  border: 1px solid #ced4da;
  color: #495057;
  line-height: 35px;
  border-radius: .25rem;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-input.active {
  background: #e9ecef;
  border-radius: .25rem;
}
.box-input .select-inside {
  flex: 1;
  border: none;
  border-radius: 0;
  border-right: 1px solid #ced4da;
}
.box-input .select-inside:last-of-type {
  border-right: none;
}

.wrapper-doc-demo {
  position: relative;
  padding: 0 0 0 40px;
  margin-top: 25px;
}

.wrapper-doc-demo-bg {
  background: #efefef;
  padding: 20px;
}

.wrapper-doc-demo-outer {
  width: 472px;
  height: 636px;
  position: relative;
  left: calc(50% - 236px);
  margin-top: -30px;
}

.wrapper-doc-demo-inner {
  transform: scale(.5) translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/custom/FormSetDefaultJournal.vue